<template>
    <form class="update-address" ref="user_address" v-on:submit.prevent="setAddress()">
        <div class="card__header">
            <p class="card__title">Update address</p>
            <div class="card__subtitle">
                <p class="body gutter">We are not operating in your new area yet. When you click save your orders will be cancelled, and your account will be put on hold until we expand to deliver to your address.</p>
            </div>
            <div class="card__subtitle">
                <div class="alert alert--notice alert--info">
                    <p class="alert__title">Subscribe to get notified when your new address becomes available on to your notification settings.</p>
                </div>
            </div>
        </div>
        <div class="card__content">
            <div class="checkbox">
                <input id="confirm" type="checkbox" value="confirm" v-model="checked" class="checkbox__control" />
                <label for="confirm" class="checkbox__label">I understand that updating my address will cancel all exisitng orders and put my account on hold.</label>
            </div>
        </div>
        <div class="card__actions">
            <button type="button" class="button button--md button--grey" v-on:click="cancel()">Update address later</button>
            <button :disabled="!checked" type="submit" class="button button--md button--secondary">Save</button>
        </div>
    </form>
</template>

<script>
export default {
    data() {
        return {
            checked: false
        }
    },
    methods: {
      setAddress: function () {
        axios.post("/api/address", this.$parent.address).then(res => {
          this.$root.address.name = res.data.address.name;
          this.$root.address.address_line_1 = res.data.address.address_line_1;
          this.$root.address.address_line_2 = res.data.address.address_line_2;
          this.$root.address.address_line_3 = res.data.address.address_line_3;
          this.$root.address.postcode = res.data.address.postcode;
          this.$root.user.address_building_type = res.data.address_building_type;
          this.$root.user.address_comments = res.data.address_comments;

          this.$root.alert = {
            type: "SUCCESS",
            title: "All good!",
            text: "Your address has been saved.",
          };

          this.cancel();
        }).catch(err => {
          this.$root.alert = {
            type: "ERROR",
            title: "Oops!",
            text: "Something went wrong. Please try again.",
          };

          this.cancel();
        });
      },
      cancel() {
        this.$root.accountAddress = 0;
        this.$parent.step = 'UPDATE';
      },
    }
}
</script>
